import { ContainerMain, Wrapper, Inner, Thumbnail, Content, Title, Subtitle, Overview, SecondHeadline } from "./styles/heroTop"
import { Container } from "../../containers"

export default function Carousel({ children, ...rest }) {
  return (
    <ContainerMain {...rest}>
      <Container>
        <Wrapper>{children}</Wrapper>
      </Container>
    </ContainerMain>
  )
}

Carousel.Inner = function CarouselInner({ children, ...rest }) {
  return <Inner>{children}</Inner>
}

Carousel.Thumbnail = function CarouselThumbnail({ path, ...rest }) {
  return (
    <Thumbnail {...rest}>
      <img src={path} alt="movie-thumb" />
    </Thumbnail>
  )
}

Carousel.Content = function CarouselContent({ children, ...rest }) {
  return <Content {...rest}>{children}</Content>
}

Carousel.Title = function CarouselTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

Carousel.Subtitle = function CarouselSubtitle({ children, ...rest }) {
  return <Subtitle {...rest}>{children}</Subtitle>
}

Carousel.SecondHeadline = function CarouselSecondHeadline({ children, ...rest }) {
  return <SecondHeadline {...rest}>{children}</SecondHeadline>
}

Carousel.Overview = function CarouselOverview({ children, ...rest }) {
  return <Overview {...rest}>{children}</Overview>
}
